import React from "react";

const G = window.glob;

const DateLabel = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: this.props.lang ?? G.getLanguageLong() ?? 'en-US',
			value: this.props.value
		};
		if ( typeof this.state.value === 'number' ) this.state.value = new Date( this.props.value );
		this.uid = G.generateUid("TextLabel");
	}
	componentDidMount() {
		if ( ! this.props.lang ) {
			G.register("Prefs", l=>{
				if ( l?.language) this.setState({ lang: G.getLanguageLong(l?.language) });
			}, this.uid);
		}
	}
	componentWillUnmount() {
		if ( ! this.props.lang ) {
			G.unregister("Prefs", this.uid);
		}
	}
	render() {
		try {
			return this.state.value.toLocaleString(this.state.lang);
		} catch (e) {
			return "—";
		}
	}
}

export default DateLabel;
